import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class mailingListView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , name: ko.observable("")
            , description: ko.observable("")
            , reference: ko.observable("")
            , welcomeEmailId: ko.observable("")
            , welcomeEmailSubject: ko.observable("")
            , unsubscriptionEmailId: ko.observable("")
            , unsubscriptionEmailSubject: ko.observable("")
            , isPrimary: ko.observable("")
            , isActive: ko.observable("")
            , isDefault: ko.observable("")
            , isEditRestricted: ko.observable(false)
            , onClickEditMailingList: function (data, event) {
                self.onClickEditMailingList(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
            <div class="w-form">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn" data-bind="visible: !isEditRestricted()">
                         <button data-bind="event: { click: onClickEditMailingList }" class="btn icon i-edit"  type="button">Edit Mailing List</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Title</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>
                                <dt>
                                    <span>Description</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: description"></span>
                                </dd>
                                <dt>
                                    <span>Reference</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: reference"></span>
                                </dd>
                                <dt>
                                    <span>Is Primary Mailing List</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isDefault"></span>
                                </dd>
                                <dt>
                                    <span>Is Primary</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isPrimary"></span>
                                </dd>
                                <dt>
                                    <span>Welcome Email ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: welcomeEmailId"></span>
                                </dd>
                                <dt>
                                    <span>Welcome Email Subject</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: welcomeEmailSubject"></span>
                                </dd>
                                <dt>
                                    <span>Unsubscription Email ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: unsubscriptionEmailId"></span>
                                </dd>
                                <dt>
                                    <span>Unsubscription Email Subject</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: unsubscriptionEmailSubject"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                </div>
        `);
    }

    protected setMailingListData(mailingList) {
        this.getTemplateViewModel().id(mailingList.id)
        this.getTemplateViewModel().name(mailingList.name)
        this.getTemplateViewModel().description(mailingList.description)
        this.getTemplateViewModel().reference(mailingList.reference)
        this.getTemplateViewModel().welcomeEmailId(mailingList.welcomeEmailId ? mailingList.welcomeEmailId : "None")
        this.getTemplateViewModel().welcomeEmailSubject(mailingList.welcomeEmailSubject ? mailingList.welcomeEmailSubject : "None")
        this.getTemplateViewModel().unsubscriptionEmailId(mailingList.unsubscriptionEmailId ? mailingList.unsubscriptionEmailId : "None")
        this.getTemplateViewModel().unsubscriptionEmailSubject(mailingList.unsubscriptionEmailSubject ? mailingList.unsubscriptionEmailSubject : "None")
        this.getTemplateViewModel().isPrimary((mailingList.isPrimary) ? "True" : "False")
        this.getTemplateViewModel().isActive((mailingList.isActive) ? "True" : "False")
        this.getTemplateViewModel().isDefault((mailingList.isDefault) ? "True" : "False")
    }

    protected getTemplateName(): string {
        return "mailingListView_template";
    }

    public setEditRestricted(flag: boolean){
        this.getTemplateViewModel().isEditRestricted(flag);
    }

    protected onClickEditMailingList(id: any): any {
        this.caller.onClickEditMailingList(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/mailingListView_template.ts